import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/app/layouts/landing.vue").then(m => m.default || m)),
  print: defineAsyncComponent(() => import("/app/layouts/print.vue").then(m => m.default || m))
}